import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { ControlContainer, NgForm } from '@angular/forms';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';

@Component({
    selector: 'family-benefits',
    templateUrl: './family-benefits.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class FamilyBenefitsComponent implements OnInit, OnDestroy, ICardComponent, DoCheck {
  public cardData: models.FamilyBenefitsVM = {} as models.FamilyBenefitsVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public disableTableRemoveIcons: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.benefitTypes)
  public benefitTypes: models.DimensionVM[];
  @CommonData(DomainCodes.subBenefitTypes)
  public subBenefitTypes: models.DimensionVM[];
  //ForTableEditComponent
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.martialStatus)
  public maritalStatuses: models.DimensionVM[];
  
  constructor(private modalService : ModalService) {
  }

  ngOnInit(): void {
    //TEMP to prevent undefined errors if no stepdata is found
    if (isNullOrUndefined(this.cardData.familyBenefitsList))
      this.cardData.familyBenefitsList= [];
  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isNullOrUndefined(this.cardData.familyBenefitsList))
      this.cardData.familyBenefitsList = [];
  }

  ngOnDestroy(): void {
  }

  onFamilyBenefitsListChanged(newList: models.FamilyBenefitEntryVM[]) {
    this.cardData.familyBenefitsList = newList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
  }
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        this.expandedRowIndex = null
      });
    }
    event.stopPropagation();
  }
  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }
}
